module.exports = __webpack_public_path__ + "img/accreditation_approval.42501b49.svg";